export default [
    {
        type: "uni",
        id: 1,
        items: [
            {
                id: 1,
                text: "Der Dozent/die Dozentin war engagiert und motiviert.",
            },
            {
                id: 2,
                text: "Ich konnte dem Tempo des Dozenten/der Dozentin gut folgen.",
            },
            {
                id: 3,
                text: "Der Dozent/die Dozentin gab die Möglichkeit, Themen zu diskutieren.",
            },
            {
                id: 4,
                text: "Der Dozent/die Dozentin war fachlich kompetent.",
            },
            {
                id: 5,
                text: "Der Dozent/die Dozentin konnte Kompliziertes verständlich machen.",
            },
            {
                id: 6,
                text: "Der Dozent/Die Dozentin motivierte die Teilnehmer/innen.",
            },
            {
                id: 7,
                text: "Die Schwerpunkte und Fragestellungen wurden mir deutlich.",
            },
            {
                id: 8,
                text: "Die Veranstaltung war übersichtlich und verständlich.",
            },
            {
                id: 9,
                text: "Der inhaltliche Aufbau der Veranstaltung war logisch/nachvollziehbar.",
            },
            {
                id: 10,
                text: "Die Schwere des Stoffes war angemessen.",
            },
            {
                id: 11,
                text: "Der Umfang des Stoffes war angemessen.",
            },
            {
                id: 12,
                text: "Das Tempo der Veranstaltung war angemessen.",
            },
            {
                id: 13,
                text: "Die Anforderungen der Veranstaltung waren angemessen.",
            },
            {
                id: 14,
                text: "Der Umfang der Arbeitsaufträge (d.h. Hausaufgaben, Gruppenarbeiten etc.) war angemessen.",
            },
            {
                id: 15,
                text: "Die Arbeitsaufträge haben mein Verständnis der Inhalte vertieft.",
            },
            {
                id: 16,
                text: "Die Arbeitsaufträge verdeutlichten die Relevanz der behandelten Themen.",
            },
            {
                id: 17,
                text: "Ich wurde durch Arbeitsaufträge zum Mitdenken motiviert.",
            },
            {
                id: 18,
                text: "Zur kritischen Auseinandersetzung mit den behandelten Themen wurde durch Arbeitsaufträge angeregt.",
            },
            {
                id: 19,
                text: "Die Arbeitsaufträge motivierten dazu, sich selbst mit den Inhalten zu beschäftigen.",
            },
            {
                id: 20,
                text: "Insgesamt fand ich die Veranstaltung gut.",
            },
            {
                id: 21,
                text: "In der Veranstaltung habe ich viel gelernt.",
            },
            {
                id: 22,
                text: "Ich würde die Veranstaltung weiterempfehlen.",
            },
        ],
    },
    {
        type: "text",
        id: 2,
        items: [
            {
                id: 23,
                text: "Besonders gut fand ich:",
            },
            {
                id: 24,
                text: "Störend fand ich:",
            },
            {
                id: 25,
                text: "Verbesserungsvorschläge:",
            },
        ],
    },
    {
        type: "text",
        id: 3,
        title: "Persönliche Angaben",
        items: [
            {
                id: 26,
                type: "small",
                text: "Semesterzahl:",
            },
            {
                id: 27,
                type: "medium",
                text: "Hauptfach/Fachstudiengang:",
            },
        ],
    },
    {
        type: "special",
        id: 4,
        items: [
            {
                id: 28,
                text: "Studiengang:",
                label: [
                    {
                        id: 1,
                        text: "Bachelor",
                    },
                    {
                        id: 2,
                        text: "Master",
                    },
                ],
            },
        ],
    },
];